import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import queryString from 'query-string';
import makeQueryString from '../../utils/makeQueryString';
import { logoutAction } from '../../redux/auth';

class Logout extends React.Component {
    componentDidMount() {
        this.props.logout(this.props.newTheme);
    }
    getUrl() {
        const { themeId, next, race } = this.props;
        if (next) {
            if (race) {
                return makeQueryString(next,
                    { event: parseInt(themeId, 10) === 2 ? 3 : themeId, race });
            }
            return next;
        }
        return '';
    }
    render() {
        return (<Redirect to={`/${this.getUrl()}`} />);
    }
}

Logout.propTypes = {
    logout: React.PropTypes.func,
    themeId: React.PropTypes.oneOfType([
        React.PropTypes.number,
        React.PropTypes.string,
    ]),
    race: React.PropTypes.string,
    next: React.PropTypes.string,
    newTheme: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.number,
    ]),
};

export default compose(
    connect(({ theme }) => ({
        themeId: theme.themeId,
    }), {
        logout: logoutAction,
    }),
    withProps(({ location: { search } }) => ({
        race: queryString.parse(search).race,
        next: queryString.parse(search).next,
        newTheme: queryString.parse(search).newTheme,
    })),
)(Logout);



/** WEBPACK FOOTER **
 ** ./src/Pages/Auth/Logout.js
 **/